import { isDefined } from 'notable-common';
import { z } from 'zod';
import { AUTOMATED_VOICE_AMAZON_VOICES } from './amazonVoices.js';
import { AUTOMATED_VOICE_GOOGLE_VOICES } from './googleVoices.js';
/** One catalog supplies the allowed voice IDs, dialing locales, labels, and provider samples. */
export const AUTOMATED_VOICE_VOICES = [
    ...AUTOMATED_VOICE_GOOGLE_VOICES.map((voice) => ({
        ...voice,
        provider: 'Google',
        sampleUrl: `https://docs.cloud.google.com/static/text-to-speech/docs/audio/${voice.id.slice('Google.'.length)}.wav`,
    })),
    ...AUTOMATED_VOICE_AMAZON_VOICES.map((voice) => ({ ...voice, provider: 'Amazon' })),
];
export const AutomatedVoiceVoiceSchema = z.enum(AUTOMATED_VOICE_VOICES.map((voice) => voice.id));
/** Resolves a selected voice, defaulting to a US Standard voice for the configured language. */
export function getAutomatedVoice(options) {
    const { voice, language } = options;
    const selectedVoice = AUTOMATED_VOICE_VOICES.find((option) => option.id ===
        (voice ?? (language === 'es' ? 'Google.es-US-Standard-A' : 'Google.en-US-Standard-F')));
    if (!isDefined(selectedVoice)) {
        throw new RangeError('Automated Voice requires a voice from the supported Standard catalog.');
    }
    return selectedVoice;
}
//# sourceMappingURL=voices.js.map